import { ErrorPageDetailsTypes } from '../../../types/errorPageDetailsTypes';

export const errorPageDetailsConstant: ErrorPageDetailsTypes = {
  description: '恐れ入りますが、しばらく経ってから再度お試しください。',
  title: 'エラーが発生しました',
};
